<div class="updates-container">
  <!-- Discord Community Section -->
  <mat-card appearance="filled" class="discord-card">
    <mat-card-content>
      <div class="discord-content">
        <div class="discord-icon-wrapper">
          <mat-icon>forum</mat-icon>
        </div>
        <div class="discord-text">
          <h3>Need help? Join our Discord community</h3>
          <p>
            Get fast support, share prompts and tips, see what others are
            creating, and chat directly with the team.
          </p>
        </div>
        <a
          mat-flat-button
          color="primary"
          href="https://discord.com/invite/PNMsFw7eMN"
          target="_blank"
          rel="noopener noreferrer"
          class="discord-button"
        >
          <mat-icon>open_in_new</mat-icon>
          Join Discord
        </a>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Feedback Form Section -->
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>feedback</mat-icon>
        Share Your Feedback
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p>
        Help us improve by sharing your thoughts, suggestions, or reporting
        issues.
      </p>

      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Your feedback</mat-label>
        <textarea
          matInput
          [(ngModel)]="feedback"
          placeholder="Tell us what you think..."
          rows="4"
          maxlength="1000"
        >
1
        </textarea>
        <mat-hint align="end">{{ feedback.length }}/1000</mat-hint>
      </mat-form-field>
    </mat-card-content>

    <mat-card-actions align="end">
      <button
        mat-flat-button
        (click)="onSubmitClicked()"
        [disabled]="!feedback.trim() || isSubmitting"
      >
        <mat-icon>send</mat-icon>
        {{ isSubmitting ? "Sending..." : "Send Feedback" }}
      </button>
    </mat-card-actions>
  </mat-card>

  <!-- Updates History Section -->
  <div class="updates-section">
    <div class="section-header">
      <h2>
        <mat-icon>history</mat-icon>
        Latest Updates
      </h2>
    </div>

    <div class="updates-list">
      @for (update of reversedUpdates; track update.date) {
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="update-date">
              <mat-icon>event</mat-icon>
              {{ update.date }}
            </mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <ul class="update-items">
              @for (item of update.updates; track item) {
                <li>{{ item }}</li>
              }
            </ul>
            @if (update.image) {
              <div class="update-image-container">
                <img
                  [src]="update.image"
                  [alt]="'Update from ' + update.date"
                  class="update-image"
                />
              </div>
            }
            @if (update.video) {
              <div class="update-image-container">
                <video
                  class="update-image"
                  style="max-height: 800px"
                  [attr.src]="update.video"
                  controls
                ></video>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
